import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

const getEntrySettings = async () => {
  const response = await agent.get(API_URL + 'game-entry/settings')
  return response.data
}

const updateVisibility = async (data) => {
  const response = await agent.post(API_URL + 'game-entry/visibility', data)
  return response.data
}

const updateJoiningMethod = async (data) => {
  const response = await agent.post(API_URL + 'game-entry/joining-method', data)
  return response.data
}

const updateEntryRequirement = async (data) => {
  const response = await agent.post(API_URL + 'game-entry/entry-requirement', data)
  return response.data
}

const updateAdditionalSetup = async (data) => {
  const response = await agent.post(API_URL + 'game-entry/additional-setup', data)
  return response.data
}

const updateConfirmation = async (data) => {
  const response = await agent.post(API_URL + 'game-entry/confirmation', data)
  return response.data
}

const GameEntryService = {
  getEntrySettings,
  updateVisibility,
  updateJoiningMethod,
  updateEntryRequirement,
  updateAdditionalSetup,
  updateConfirmation,
}

export default GameEntryService
